import { SalaryVm } from '../../../utils/api';
import SalariesCopyForm from './SalariesCopyForm';

interface OwnProps {
    companyId?: number;
    onClose: () => void;
    onSuccess: (records: SalaryVm[]) => void;
}

export type Props = OwnProps;

export default SalariesCopyForm;
